<template>
	<div class="vforms-input">
		<div
			class="vforms-input-radio"
			v-for="(option, index) in options"
			:key="index"
		>
			<input
				v-model="inputValue"
				:id="`${name}-${option.value}`"
				:name="name"
				:type="`radio`"
				:value="option.value"
				:placeholder="placeholder"
				:class="inputClassListLive"
				:readonly="readonlyLive"
				:required="requiredLive"
				:disabled="disabledLive"
				:title="inputValue"

				@change="onChangeHandler"
				@input="onInputHandler"
				@focus="onFocusHandler"
				@blur="onBlurHandler"
			>
			<label :for="option.name">{{ option.label }}</label>
			<slot name="icon" :option="option"></slot>
		</div>
	</div>
</template>

<script>
import {baseInput} from './../mixins/index.js';

export default {
	name: 'RadioInput',
	props: {
		options: {type: Array, required: false, default: () => []}
	},
	mixins: [
		baseInput
	]
};
</script>
